import { useEffect, useRef, useState } from "react";
import { useSorting, useTablePage } from "@wptb/utils/react";
/**
 * Do not install @wptb/components
 * or change the imports to "@wptb/external/components"
 * They have to be relative path because
 * gutenberg & WPTB uses two different instances of react
 *
 * aliasing is an option but it has only one use case rn
 */
import Pagination from "../../../../../packages/ui/components/pagination";
import TableList from "../../../../../packages/ui/components/table-list";

interface TablesProps {
  search?: string;
  onSelect: (id: number) => void;
}

const Tables = ({ search, onSelect }: TablesProps) => {
  const abortCtrl = useRef<AbortController>();
  const [page, setPage] = useState(1);
  const sorting = useSorting<string>("modified", "desc");
  const tOutRef = useRef<NodeJS.Timeout>();
  const [searchTxt, setSearch] = useState(search);

  const [apiData] = useTablePage({
    page,
    search: searchTxt,
    sort: sorting[0],
    abortCtrl: abortCtrl.current,
  });

  useEffect(() => {
    const newSearch = search?.trim();
    if (!searchTxt) {
      if (!newSearch || newSearch.length < 2) {
        return;
      }
    } else if (newSearch && newSearch.length > 0 && newSearch.length < 2) {
      return;
    }
    if (tOutRef.current) {
      clearTimeout(tOutRef.current);
    }
    if (abortCtrl.current) {
      abortCtrl.current.abort();
    }
    abortCtrl.current = new AbortController();
    tOutRef.current = setTimeout(() => {
      setSearch(newSearch);
      abortCtrl.current = undefined;
      tOutRef.current = undefined;
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <>
      <p className="wptb-pagination-info">
        Showing <b>{apiData.page_start}</b> to <b>{apiData.page_end}</b> of{" "}
        <b>{apiData.total_count}</b> entries
      </p>
      <TableList
        isLoading={apiData.loading}
        items={apiData.posts}
        onSelect={(t) => onSelect(t.id)}
        sorting={sorting}
        columns={["id", "title", "modified"]}
        htmlColumns={{
          title: true,
        }}
      />
      <Pagination apiData={apiData} setPage={setPage} />
    </>
  );
};
export default Tables;
